const inboxShownTrackEvent = () => {};

const categoryChange = (category) => {};

const statusFilterApplied = (userId) => {};

const roomFilterApplied = (userId) => {};

const inboxTrackingEvents = () => {
  return {
    inboxShown: () => inboxShownTrackEvent(),
    categoryChange,
    statusFilterApplied,
    roomFilterApplied,
  };
};

export default inboxTrackingEvents;
